/**
 * Created by CoolGuy on 2016/11/27.
 */
import React from 'react'
import { Link } from 'react-router-dom'

export default (props)=>{
    return (
        <Link {...props} >{props.children}</Link>
    )
}



// WEBPACK FOOTER //
// ./src/components/NavLink/index.js